module.exports = __webpack_public_path__ + "img/ring_y_c_1_1.d8aa2a9e.png";